import styled from "styled-components";

import { LinkButton } from "../Banner/index.style";

import {
  borderRadius,
  boxShadowColor,
  lightColor,
  secondaryColor,
  primaryColor,
} from "../variables.styles";

export const SummaryContainer = styled.div`
  background-color: ${primaryColor};
  color: ${lightColor};
  padding: 5rem;
  text-align: center;

  @media (min-width: 800px) {
    grid-template-columns: repeat(3, 300px);
    display: grid;
    grid-gap: 3rem;
    place-content: center;
  }
`;

export const Card = styled.div`
  background-color: ${lightColor};
  color: rga(0, 0, 0);
  padding: 4rem 1rem 3rem;
  box-shadow: 0 0 3px 2px ${boxShadowColor};
  border-radius: ${borderRadius};
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  span {
    font-size: 2.5em;
    color: ${secondaryColor};
  }
  h3 {
    text-transform: uppercase;
    color: ${primaryColor};
    font-size: 1.7rem;
    font-weight: bold;
  }
  p {
    color: rgba(0, 0, 0, 0.7);
  }
`;

export const SummaryTitle = styled.div`
  margin: 0 auto;
  h2 {
    text-transform: uppercase;
  }

  p {
    max-width: 80%;
    margin: auto;
  }

  @media (min-width: 700px) {
    grid-column: 1 / -1;
  }
`;

export const SummaryButton = styled(LinkButton)`
  background-color: ${primaryColor};
  padding: 1rem 3rem;
  width: 75%;
  margin: 0 auto;

  &::after {
    content: "\f061";
    font-family: FontAwesome;
    display: inline-block;
    padding: 0 0 0 0.5rem;
  }
`;
